import { FormsManager } from "@/components/FormsManager";

export default function CorporateForms() {
  return (
    <main className="px-6 md:px-10 py-8" data-testid="corporate-forms-page">
      <FormsManager isCorporate />
    </main>
  );
}
